import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Screening } from 'src/app/models/screeningInvite';
import { SearchPackage } from 'src/app/packages-module/models/searchPackage';
import { AuthService } from 'src/app/services/auth.service';
import { UserLight } from 'src/app/users-module/models/userLight';
import { ScreeningDraftService } from '../../services/screening-draft.service';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { PaymentsService } from 'src/app/services/payments.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { ClientLocation, Client } from 'src/app/clients-module/models/clientLocation';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-order-summary',
  templateUrl: './create-order-summary.component.html',
  styleUrls: ['./create-order-summary.component.less']
})
export class CreateOrderSummaryComponent implements OnInit {
  @Output() public phaseComplete: EventEmitter<number> = new EventEmitter();
  package: SearchPackage;
  client : Client;
  property : ClientLocation;
  user: UserLight;
  loading: boolean = true;

  public get convertedDraft() : Screening {
    return this.drafts.convertedDraft;
  }
  
  public get packageCost() : number {
    if (this.drafts.clientPackageOverrides) {
      const override = this.drafts.clientPackageOverrides.find(spo => {
        return spo.searchPackageId === this.package.id;
      });
      if (override) {
        this.package.cost = override.clientPackageCost;
      }
    }
    return this.package.cost;
  }

  constructor( public auth: AuthService, public toastr : ToastrService,
    private drafts: ScreeningDraftService, 
    public clients: ClientService, 
    public properties : PropertyService, 
    public pkgs : SearchPackageService,
    public pmts : PaymentsService,
    public modalService : NgbModal,
    public location: Router) { }

  ngOnInit() {
    console.log('DAT CONVERTED',this.convertedDraft);
    forkJoin([
      this.clients.GetClientById(this.drafts.directOrderDemographics.clientId), 
      this.properties.FetchProperty(this.drafts.directOrderDemographics.clientLocationId), 
      this.pkgs.FetchSearchPackageById(this.drafts.directOrderDemographics.searchPackageId),
      this.auth.FetchUser(!this.drafts.directOrderDemographics.requestingUserId ? this.drafts.directOrderDemographics.userId : this.drafts.directOrderDemographics.requestingUserId)
    ]).subscribe(results =>{
      this.client = results[0];
      this.property = results[1];
      this.package = Object.assign(new SearchPackage(),results[2][0]);
      this.user = results[3];
    },(err: any)=>{
      this.toastr.error('Error loading data for draft')
    },()=>{
      this.loading = false;
    });
  }

  startNewInvite(): void {
    //
    this.location.navigateByUrl('screenings/new');
  }

}
